import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { to: '/enrollments', label: 'Liste des étudiants' },
  { to: '/admin', label: 'Administration' },
];

// The sidebar of /admin: the brand of Sidebar.js, links instead of the filters.
function AdminSidebar() {
  const { pathname } = useLocation();

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        {links.map(({ to, label }) => (
          <li key={to} className={(pathname === to) ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <Link className="nav-link" to={to}>
              <span className="menu-title">{label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default AdminSidebar;
